import { FilterOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, Form, Select, Tag } from "antd";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { getTemplateLabels } from "../../../api/settings/email-template";

const STATUS_OPTIONS = [
  { label: "Active", value: "true" },
  { label: "Inactive", value: "false" },
];

const MULTILINGUAL_OPTIONS = [
  { label: "Yes", value: "true" },
  { label: "No", value: "false" },
];

const TemplateFilterForm = ({ data, ...otherProps }) => {
  const [form] = Form.useForm();
  const [allLabels, setAllLabels] = useState([]);

  useEffect(() => {
    getTemplateLabels().then(setAllLabels).catch(() => {});
  }, []);

  const clearForm = () => {
    form.setFieldsValue(
      Object.fromEntries(Object.keys(form.getFieldsValue()).map((k) => [k, null]))
    );
    form.submit();
  };

  return (
    <Form form={form} initialValues={data} layout="vertical" {...otherProps}>
      <Form.Item name="active" label="Status">
        <Select allowClear placeholder="Any" options={STATUS_OPTIONS} />
      </Form.Item>
      <Form.Item name="multilingual" label="Multilingual">
        <Select allowClear placeholder="Any" options={MULTILINGUAL_OPTIONS} />
      </Form.Item>
      <Form.Item name="labels" label="Labels">
        <Select
          mode="multiple"
          allowClear
          placeholder="Any"
          options={allLabels.map((l) => ({
            value: String(l.id),
            label: l.name,
          }))}
          tagRender={({ value, closable, onClose }) => {
            const l = allLabels.find((x) => String(x.id) === String(value));
            if (!l) return null;
            return (
              <Tag
                color={l.color}
                closable={closable}
                onClose={onClose}
                bordered={false}
                style={{ borderRadius: 5, margin: "2px 2px", padding: "3px 8px", lineHeight: 1 }}
              >
                {l.name}
              </Tag>
            );
          }}
          optionRender={({ data }) => {
            const l = allLabels.find((x) => String(x.id) === String(data.value));
            if (!l) return data.label;
            return (
              <Tag color={l.color} style={{ borderRadius: 5, margin: 0, padding: "3px 8px", lineHeight: 1 }}>
                {l.name}
              </Tag>
            );
          }}
        />
      </Form.Item>
      <Form.Item label=" ">
        <Button htmlType="submit" type="primary" icon={<FilterOutlined />}>
          Apply
        </Button>
        <Button onClick={clearForm} icon={<ReloadOutlined />} style={{ marginLeft: 8 }}>
          Reset
        </Button>
      </Form.Item>
    </Form>
  );
};

TemplateFilterForm.propTypes = {
  data: PropTypes.object,
};

export default TemplateFilterForm;
